export { SiteWidthMigrationEntryPoint } from './scope';
